














import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HelloWord extends Vue {
  form: any = {
    name: '123',
  };
}
